import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IPropertyListItemDTO} from "../../properties/types/IPropertyListItemDTO";
import {getAmplitudePropertyItem} from "./get_amplitude_property_item";

interface ITrackAmplitudeSelectItemParams {
    property: IPropertyListItemDTO;
    itemListName: string;
    index?: number;
    itemListId?: string | null;
    location?: string;
}

export const trackAmplitudeSelectItem = (params: ITrackAmplitudeSelectItemParams) => {
    const {property, itemListName, index, itemListId, location} = params;
    const eventProperties: Record<string, string | number | boolean | null> = {
        item_list_name: itemListName,
        ...getAmplitudePropertyItem({property, index})
    };

    if (itemListId !== undefined) eventProperties.item_list_id = itemListId;
    if (location) eventProperties.location = location;

    if (eventProperties.price != null) {
        eventProperties.item_price = eventProperties.price;
        delete eventProperties.price;
    }

    trackAmplitudeEvent("select_item", eventProperties);
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IPropertyListItemDTO} from "../../properties/types/IPropertyListItemDTO";
import {getAmplitudePropertyItem} from "./get_amplitude_property_item";

interface ITrackAmplitudeSelectItemParams {
    property: IPropertyListItemDTO;
    itemListName: string;
    index?: number;
    itemListId?: string | null;
    location?: string;
}

export const trackAmplitudeSelectItem = (params: ITrackAmplitudeSelectItemParams) => {
    const {property, itemListName, index, itemListId, location} = params;
    const eventProperties: Record<string, string | number | boolean | null> = {
        item_list_name: itemListName,
        ...getAmplitudePropertyItem({property, index})
    };

    if (itemListId !== undefined) eventProperties.item_list_id = itemListId;
    if (location) eventProperties.location = location;

    if (eventProperties.price != null) {
        eventProperties.item_price = eventProperties.price;
        delete eventProperties.price;
    }

    trackAmplitudeEvent("select_item", eventProperties);
};
